import { Table } from 'antd';
import React from 'react';

// Port NGUYÊN VĂN từ ra-log-monitor-cms/source/src/containers/log/LogTable.js.
// KHÁC BaseTable: scroll={{ x: false, y: '66vh' }} — bảng trong modal chi tiết cuộn DỌC,
// không cuộn ngang.
const LogTable = (props) => (
    <Table
        className="base-table"
        size="middle"
        scroll={{ x: false, y: '66vh' }}
        {...props}
        pagination={props.pagination ? { ...props.pagination, showSizeChanger: false, hideOnSinglePage: true } : false}
    />
);

export default LogTable;
